
import ApiService from '../service/ApiService';
import ApiServiceAxios from '../service/ApiServiceAxios';
import MethodService from '../service/MethodService';

let moduleApi = {};
let token = MethodService.getToken();
let UrlApiKhaoSat = window.MyConfig.UrlApiKhaoSat;
let UrlHostApi831 = window.MyConfig.hostApi831;

moduleApi.GetHoSo831ByHSSKCN_ID = async (HSSKCN_ID) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "GetHoSo831ByHSSKCN_ID",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB,
      HSSKCN_ID: HSSKCN_ID
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.GetHSSKByHSSKCN_ID = async (HSSKCN_ID) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "GetHSSK_CN",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB,
      HSSKCN_ID: HSSKCN_ID
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};


// chưa có
moduleApi.getHSSKCN = async (MaDangKyOrMaThe) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "GetHoSo831ByMaDangKy",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB,
      MaDangKy: MaDangKyOrMaThe
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.getHSSKCNByAccount = async () => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "GetListHSSK_CNByAccount",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB,
      UserName: currentUser.UserName
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
}
moduleApi.updateHSSKCN = async (dataForm) => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_CNAsync",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Cập nhật không thành công",
    },
  };

  return ApiServiceAxios(api);
};

moduleApi.getHSSK831 = async (MaDangKy) => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {    
    method: "GET",
    url: UrlHostApi831 + "GetHoSo831ByMaDangKy",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaDangKy: MaDangKy
    },
    message: {
      success: "",
      error: "Lấy HSSK 831 không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.updateBHYT = async (dataForm) => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_BHYT",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Cập nhật không thành công",
    },
  };

  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_TT_LUC_SINH = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_TT_LUC_SINH",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_YTSK = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_YTSK",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_KTAT = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_KTAT",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_PTHUAT = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_PTHUAT",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_SKSS = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_SKSS",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_VANDE_KHAC = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_VANDE_KHAC",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_DIUNG = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_DIUNG",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_DIUNG_GD = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_DIUNG_GD",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_BENHTAT = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_BENHTAT",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_BENHTATGD = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_BENHTATGD",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.SaveHSSK_TCHUNG_UVAN = async (dataForm) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SaveHSSK_TCHUNG_UVAN",
    data: dataForm,
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    }
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMQuocGia = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMQuocGia",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };

  return ApiServiceAxios(api);
};

moduleApi.LoadDMDanToc = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMDanToc",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };

  return ApiServiceAxios(api);
};

moduleApi.LoadDMGioiTinh = async () => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMGioiTinh",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMCSKCB = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMCSKCB",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMTonGiao = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMTonGiao",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMKhuyetTat = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMKhuyetTat",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMKhoa = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMKhoa",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMTinhThanh = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMTinhThanh",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMQuanHuyen = async (MaTinhThanh) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMQuanHuyen",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  if (MaTinhThanh) {
    api.params.MaTinhThanh = MaTinhThanh;
  }
  return ApiServiceAxios(api);
};

moduleApi.LoadDMPhuongXa = async (MaTinhThanh, MaQuanHuyen) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMPhuongXa",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  if (MaTinhThanh) {
    api.params.MaTinhThanh = MaTinhThanh;
  }
  if (MaQuanHuyen) {
    api.params.MaQuanHuyen = MaQuanHuyen;
  }
  return ApiServiceAxios(api);
};
moduleApi.LoadDMCoSoCachLy = async (MaTinhThanh) => {
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMDiaDiemCachLy",
    // data: {},
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: MaTinhThanh
    },
    message: {
      success: "",
      error: "Tải dữ liệu danh mục không thành công",
    },
  };
  if (MaTinhThanh) {
    api.params.MaTinhThanh = MaTinhThanh;
  }
  // if (MaQuanHuyen) {
  //   api.params.MaQuanHuyen = MaQuanHuyen;
  // }
  return ApiServiceAxios(api);
};
moduleApi.SaveUser = async () => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "SaveUser",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMUserByMaCSKCB = async (MaCSKCB) => {

  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMUserByMaCSKCB",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB,
      MaCSKCB: MaCSKCB
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.LoadDMUserByUserName = async (cardCode, token) => {
  let api = {
    method: "GET",
    url: UrlApiKhaoSat + "LoadDMUserByUserName",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: '',
      UserName: cardCode
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiServiceAxios(api);
};

moduleApi.SearchHSSK_CN = async (dataForm) => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "SearchHSSK_CN",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanhSoYTe: currentUser.MaTinhThanhCSKCB
    },
    data: {
      HoVaTen: dataForm.HoVaTen ? dataForm.HoVaTen : '',
      NgaySinh: dataForm.NgaySinh ? dataForm.NgaySinh : '',
      GioiTinh: dataForm.GioiTinh ? dataForm.GioiTinh : '',
      MaTinhThanhHoKhau: '',
      MaQuanHuyenHoKhau: '',
      MaPhuongXaHoKhau: '',
      SoCMND: dataForm.SoCMND ? dataForm.SoCMND : '',
      SoTheBHYT: dataForm.SoTheBHYT ? dataForm.SoTheBHYT : '',
      SoDienThoai: dataForm.SoDienThoai ? dataForm.SoDienThoai : '',
      MaTheHoacMaDangKy: dataForm.MaTheHoacMaDangKy ? dataForm.MaTheHoacMaDangKy : '',
      MaHoGD: dataForm.MaHoGD ? dataForm.MaHoGD : '',
      MaTinhThanhNoiOHienTai: dataForm.MaTinhThanhHoKhau ? dataForm.MaTinhThanhHoKhau : '',
      MaQuanHuyenNoiOHienTai: dataForm.MaQuanHuyenHoKhau ? dataForm.MaQuanHuyenHoKhau : '',
      MaPhuongXaNoiOHienTai: dataForm.MaPhuongXaHoKhau ? dataForm.MaPhuongXaHoKhau : '',
    },
    message: {
      success: "",
      error: "Tìm kiếm người dân không thành công",
    },
  };
  return ApiServiceAxios(api);
};

/* có thay đổi cách seacrh nhé
có thể search 1 trong 5 thông tin sau
- CMND
- Số BHYT
- Số dthoai
- Mã thẻ hoặc mã MS
- Bộ thông tin hành chính (họ tên, ngày sinh, giới tính, mã tỉnh thành hộ khẩu, mã quận huyện hộ khẩu, mã phường xã hộ khẩu)


1 trong 5 nhóm thông tin này có dữ liệu là cho search chứ không nhất nhiết phải đầy đủ all 5 nhóm thông tin
riêng phần bộ thông tin hành chính, mấy ông bổ sung thêm Mã Tỉnh / thành, quận /huyện, phường xã đăng ký hộ khẩu để đủ điều kiện search nhé
 */


moduleApi.getBieuMau1 = (cardCode) => {
  let api = {
    module: "survey",
    type: "bieu_mau_1",
    value: {
      card_Code: cardCode
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiService(api);
};

moduleApi.getBieuMau2 = async (body) => {
  //  body =   {
  //     ma_tinh = "",
  //     ma_huyen = "",
  //     ma_xa = "",
  //     ma_cscl = "",
  //     ngay_theo_doi = ""
  // }
  let api = {
    module: "survey",
    type: "bieu_mau_2_3",
    value: body,
    message: {
      success: "",
      error: "",
    },
  };
  return ApiService(api);
};

moduleApi.DoiMatKhau = async (dataForm) => {
  let currentUser = MethodService.getCurrentUserBS();
  token = MethodService.checkToken(token);
  let api = {
    method: "POST",
    url: UrlApiKhaoSat + "DoiMatKhau",
    params: {
      token: token,
      ApplicationCode: window.MyConfig.applicationCode831,
      MaTinhThanh: currentUser.MaTinhThanhCSKCB
    },
    data: dataForm,
    message: {
      success: "",
      error: "Đổi mật khẩu không thành công",
    },
  };
  return ApiServiceAxios(api);
};


export default moduleApi;
